import { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import GetIcon from "../../../../utils/Icon";
const Tab1Table1 = ({
	setselected_uom_item_data,
	list_uom_data,
	setRows,
	rows,
}) => {
	const createNewRow = () => ({
		uom: "",
		conversion_factor: "",
	});
	const navigate = useNavigate();
	const tableRef = useRef();
	const dropdownRef = useRef();
	const [rowsPerPage] = useState(10);
	const [offset, setOffset] = useState(0);
	const [hasMore, setHasMore] = useState(true);
	const [item_uom_list, setitem_uom_list] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	// const [rows, setRows] = useState([createNewRow()]);
	const [selectedRows, setSelectedRows] = useState([]);
	const [search_input, setsearch_input] = useState("");
	const [showDropdown, setShowDropdown] = useState(false);
	const [focusedCell, setFocusedCell] = useState({
		rowIndex: null,
		field: null,
	});
	const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
	const indexOfLastRow = currentPage * rowsPerPage;
	const indexOfFirstRow = indexOfLastRow - rowsPerPage;
	const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);

	const handleSelectAll = (e) => {
		if (e.target.checked) {
			const allRowIndices = rows.map((_, index) => index);
			setSelectedRows(allRowIndices);
		} else {
			setSelectedRows([]);
		}
	};

	const getItemdata = async (newOffset = 0, searchText = "") => {
		const res = await list_uom_data({
			start: newOffset,
			search_input: searchText,
		});
		const products = res?.data?.data || [];
		// console.log('uom list:',products)
		if (newOffset === 0) {
			setitem_uom_list(products);
		} else {
			setitem_uom_list((prev) => [...prev, ...products]);
		}
		setHasMore(products.length === 20);
	};

	// const updateRow = (index, field, value) => {
	//   const updatedRows = [...rows];
	//   updatedRows[index][field] = value;
	//   setRows(updatedRows);
	//   setselected_uom_item_data(updatedRows)
	// };
	const updateRow = (index, field, value) => {
		const updatedRows = [...rows];

		// Ensure item exists
		if (!updatedRows[index].item) {
			updatedRows[index].item = {};
		}

		updatedRows[index].item[field] = value;

		setRows(updatedRows);
		setselected_uom_item_data(updatedRows);
	};

	const toggleRowSelection = (index) => {
		setSelectedRows((prev) =>
			prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
		);
	};

	const handleAddRow = () => {
		const newRows = [...rows, createNewRow()];
		setRows(newRows);
		setselected_uom_item_data(newRows);
		const lastPage = Math.ceil(newRows.length / rowsPerPage);
		if (currentPage !== lastPage) {
			setCurrentPage(lastPage);
		}
	};

	const handleDeleteSelectedRows = () => {
		const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
		setRows(updatedRows);
		setselected_uom_item_data(updatedRows);
		setSelectedRows([]);
		const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
		if (currentPage > lastPage) {
			setCurrentPage(lastPage);
		}
	};

	useEffect(() => {
		getItemdata(0, "");
	}, []);

	useEffect(() => {
		const dropdown = dropdownRef.current;
		if (!dropdown) return;
		const handleScroll = () => {
			if (
				dropdown.scrollTop + dropdown.clientHeight >=
					dropdown.scrollHeight - 10 &&
				hasMore
			) {
				const newOffset = offset + 20;
				setOffset(newOffset);
				getItemdata(newOffset, search_input);
			}
		};
		dropdown.addEventListener("scroll", handleScroll);
		return () => dropdown.removeEventListener("scroll", handleScroll);
	}, [offset, hasMore, search_input]);

	useEffect(() => {
		const cols = tableRef.current.querySelectorAll("th");
		cols.forEach((col) => {
			const resizer = document.createElement("div");
			resizer.className = "resizer";
			col.appendChild(resizer);

			let x = 0;
			let w = 0;

			const onMouseDown = (e) => {
				x = e.clientX;
				w = col.offsetWidth;

				document.addEventListener("mousemove", onMouseMove);
				document.addEventListener("mouseup", onMouseUp);
			};

			const onMouseMove = (e) => {
				const dx = e.clientX - x;
				col.style.width = `${w + dx}px`;
			};

			const onMouseUp = () => {
				document.removeEventListener("mousemove", onMouseMove);
				document.removeEventListener("mouseup", onMouseUp);
			};

			resizer.addEventListener("mousedown", onMouseDown);
		});
	}, []);

	return (
		<div className="">
			<table className="table table-bordered mb-1" ref={tableRef}>
				<thead className="tableHead1">
					<tr>
						{[
							"Action",
							"S.No",
							"UOM",
							"Conversion Factor",
							// <GetIcon iconName="PiSlidersHorizontalBold" size={12} />,
						].map((title, i) => {
							const isIcon = typeof title !== "string";
							const defaultWidths = {
								Action: "20px",
								"S.No": "20px",
								UOM: "110px",
								"Conversion Factor": "220px",
								// Action1: "100px",
							};

							return (
								<th
									key={i}
									style={{
										fontSize: "7px",
										position: "relative",
										textAlign:
											title === "Action" ||
											title === "S.No" ||
											title === "isIcon"
												? "center"
												: "center",
										width:
											typeof title === "string"
												? defaultWidths[title] || "220px"
												: "220px",
										minWidth:
											typeof title === "string"
												? defaultWidths[title] || "220px"
												: "220px",
									}}
								>
									{title === "Action" ? (
										<input
											type="checkbox"
											className="form-check-input"
											style={{
												backgroundColor: isAllSelected ? "#270b79" : "",
												borderColor: isAllSelected ? "#270b79" : "",
												fontSize: "15px",
											}}
											checked={isAllSelected}
											onChange={handleSelectAll}
										/>
									) : isIcon ? (
										<div
											style={{
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											{title}
										</div>
									) : (
										title
									)}
								</th>
							);
						})}
					</tr>
				</thead>

				<tbody>
					{currentRows.map((row, index) => {
						const globalIndex = indexOfFirstRow + index;
						return (
							<tr key={globalIndex}>
								<td className="p-0" style={{ cursor: "pointer" }}>
									<p
										className="m-0"
										style={{ position: "relative", top: "5px" }}
									>
										{selectedRows.includes(globalIndex) ? (
											<span onClick={() => toggleRowSelection(globalIndex)}>
												<input
													type="checkbox"
													className="form-check-input"
													style={{
														backgroundColor: "#270b79",
														fontSize: "15px",
														borderColor: "#270b79",
													}}
													checked
												/>
											</span>
										) : (
											<span onClick={() => toggleRowSelection(globalIndex)}>
												<input
													type="checkbox"
													className="form-check-input"
													style={{ fontSize: "15px" }}
												/>
											</span>
										)}
									</p>
								</td>
								<td
									style={{
										textAlign: "center",
										fontSize: "0.8rem",
										padding: "0.5rem",
									}}
								>
									{globalIndex + 1}
								</td>

								<td
									className="p-0 d-flex justify-content-center"
									style={{
										position: "relative",
										border:
											focusedCell.rowIndex === globalIndex &&
											focusedCell.field === "uom"
												? "0.3px solid #270b79"
												: "",
									}}
								>
									<input
										type="text"
										className="form-control tableinput noborder"
										style={{ textAlign: "center", fontSize: "0.8rem" }}
										placeholder="Select UOM"
										onFocus={() => {
											setShowDropdown(globalIndex);
											setFocusedCell({ rowIndex: globalIndex, field: "uom" });
										}}
										onBlur={() => {
											setTimeout(() => setShowDropdown(false), 300);
										}}
										onChange={(e) => {
											setsearch_input(e.target.value);
											setOffset(0);
											getItemdata(0, e.target.value);
											updateRow(globalIndex, "uom", e.target.value);
										}}
										value={row.item?.uom || row.uom || ""}
									/>
									<div
										ref={dropdownRef}
										style={{
											position: "absolute",

											top: "100%",
											left: 0,
											right: 0,
											maxHeight: showDropdown === globalIndex ? "200px" : "0",
											display: showDropdown === globalIndex ? "" : "none",
											overflowY: "auto",
											background: "white",
											border:
												showDropdown === globalIndex ? "1px solid #ccc" : "",
											zIndex: 10,
										}}
									>
										{[{ isNew: true }, ...item_uom_list].map((item, idx) => (
											<div
												key={idx}
												className="text-start"
												onClick={() => {
													if (item.isNew) {
														navigate("/master/uom/create-uom");
													} else {
														updateRow(globalIndex, "uom", item.name);
													}
													setsearch_input("");
													setShowDropdown(false);
												}}
												style={{
													padding: "8px",
													cursor: "pointer",
													borderBottom: "1px solid #eee",
													backgroundColor: item.isNew ? "#fc8b5c" : "#fff", // ✅ Background color
													color: item.isNew ? "#fff" : "inherit", // ✅ Text color
													fontWeight: item.isNew ? "bold" : "normal",
												}}
											>
												{item.isNew ? "+ Create New UOM" : item.name}
											</div>
										))}

										{!hasMore && item_uom_list.length === 0 && (
											<div style={{ padding: "8px", color: "#888" }}>
												No results
											</div>
										)}
									</div>
								</td>

								<td
									className="p-0"
									style={{
										border:
											focusedCell.rowIndex === globalIndex &&
											focusedCell.field === "conversion_factor"
												? "0.3px solid #270b79"
												: "",
									}}
								>
									<input
										type="text"
										placeholder="Conversion Factor"
										className="form-control tableinput noborder"
										style={{ textAlign: "center", fontSize: "0.8rem" }}
										onFocus={() =>
											setFocusedCell({
												rowIndex: globalIndex,
												field: "conversion_factor",
											})
										}
										onBlur={() =>
											setFocusedCell({ rowIndex: null, field: null })
										}
										value={
											row?.item?.conversion_factor ||
											row?.conversion_factor ||
											""
										}
										onChange={(e) =>
											updateRow(
												globalIndex,
												"conversion_factor",
												e.target.value
											)
										}
									/>
								</td>

								{/* <td
									style={{
										position: "relative",
										width: "40px",
									}}
								>
									<img
										src="/Maskgroup.png"
										alt="edit"
										style={{
											position: "absolute",
											top: "50%",
											left: "50%",
											transform: "translate(-50%, -50%)",
											width: "12px",
											height: "12px",
											pointerEvents: "none",
										}}
									/>
								</td> */}
							</tr>
						);
					})}
				</tbody>
			</table>

			<div
				className="d-flex pb-2  justify-content-between align-items-center"
				style={{ marginTop: "12px", marginBottom: "16px" }}
			>
				<div className="d-flex" style={{ gap: "4px" }}>
					{selectedRows.length > 0 && (
						<Button
							onClick={handleDeleteSelectedRows}
							className="customdeletebtn "
							iconName="MdDeleteOutline"
							iconSize={12}
						>
							Delete
						</Button>
					)}
					{selectedRows.length == 0 && (
						<Button
							onClick={handleAddRow}
							className="Addrowdesign"
							iconName="FiPlus"
							iconSize={12}
							iconWrapperStyle={{
								backgroundColor: "#ff8d5c",
								padding: "1px",
								display: "flex",
							}}
						>
							Add Row
						</Button>
					)}
				</div>

				<div
					className={`${
						rows.length < 11 ? "d-none" : "d-flex"
					} align-items-center centerpagination`}
					style={{ gap: "5px" }}
				>
					<Pagination
						setCurrentPage={setCurrentPage}
						currentPage={currentPage}
						pageSize={rowsPerPage}
						totalrecords={rows.length}
					/>
				</div>

				<div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
					<span className="px-2" style={{ fontSize: "12px", color: "#270B79" }}>
						Showing {indexOfFirstRow + 1} to{" "}
						{Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
					</span>
				</div>
			</div>
		</div>
	);
};

export default Tab1Table1;
